<template>
  <div>
    <modal name="eventDetailModal" id="eventDetailModal" class="custom-modal" :width="'75%'" :height="'auto'"
           :scrollable="true" :pivotX="1.0" :minWidth="900" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose" @opened="opened"
           :clickToClose="true" >
      <div class="detail-modal" @click="onSave">
        <div :class="{'isLoading': getIsLoadingModal, 'noDisplay': !getIsLoadingModal}" class="overlay">
          <div class="spinner-align">
            <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
          </div>
        </div>
        <div v-if="!getIsLoadingModal" class="modal-padding">
          <div class="event-detail-header row">
            <div class="col-md-6 noPaddingLeft d-flex">
              <span class="event-details text-nowrap">{{event.eventName}}</span>
              <div class="add-on-wrapper ml-5">
                <div class="event-add-on">
                  <input type="checkbox" :disabled="isReadOnly" v-model="event.isLive" id="is-live" @change="updateIsLiveEvent('LIVE')"/>
                  <label for="is-live">Toggle</label>
                </div>
                <div class="text" :class="{'online-text': event.isLive}">Live</div>
              </div>
            </div>

            <div class="col-md-6 noPaddingRight align-right-item">
              <div class="modal-close-img" @click="hideModal">
                <div class="icon-close"></div>
              </div>
            </div>
          </div>

          <!-- Event Information -->
          <!-- Title -->
          <div class="event-detail-body row margin-top-24px">
            <div class="col-md-6 event-information noPaddingLeft">
              Event information
            </div>
            <div class="col-md-6 event-information noPaddingRight align-right-item">
              <div class="staffing-edit-btn">
                <button v-if="editing" class="ap-btn secondary btn-save" @click="onSave" :disabled="loadingUpdate">
                  <b-spinner v-if="loadingUpdate"></b-spinner>
                  Save
                </button>
                <button v-else class="ap-btn secondary" :disabled="isReadOnly" @click="onEdit">Edit</button>
              </div>
            </div>
          </div>

          <!-- Event Name, Date, Client, Planning Notes -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-3">
              <span class="event-title">Event Name</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.eventName"></textarea>
                <span v-else @dblclick="onEdit">{{event.eventName}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Date</span><br/>
              <div class="event-info">
                <date-picker v-if="editing" v-model="event.prefDate" :format="'MMMM d, yyyy'"></date-picker>
                <span v-else @dblclick="onEdit">{{event.prefDate | dateFormatMMMM}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Client</span><br/>
              <div class="event-info">{{event.clientName}}</div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Custom Event Notes</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.customEventNote"></textarea>
                <span v-else @dblclick="onEdit">{{event.customEventNote}}</span>
              </div>
            </div>
          </div>

          <!-- Address, Time and Duration, Program, On Site Constructions -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-3">
              <span class="event-title">Address</span><br/>
              <div class="event-info">
                <vue-google-autocomplete name="address-input"
                                         v-if="editing"
                                         id="map_address"
                                         :classname="form-control"
                                         placeholder="Address"
                                         :country="['us']"
                                         :item="event"
                                         v-on:placechanged="setPlace"
                ></vue-google-autocomplete>
                <span v-else @dblclick="onEdit">{{event.fullAddress}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Time and Duration</span><br/>
              <div class="event-info show-dropdown">
                <table>
                  <tr>
                    <td>Start: </td>
                    <td>
                      <select v-if="editing" v-model="event.startTime" @change="onChangeStartTime">
                        <option v-for="time in listTime" :value="time.name">{{time.name}}</option>
                      </select>
                      <span v-else @dblclick="onEdit">{{event.startTime}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>End: </td>
                    <td>
                      <select v-if="editing" v-model="event.endTime" @change="onChangeEndTime">
                        <option v-for="time in listTime" :value="time.name">{{time.name}}</option>
                      </select>
                      <span v-else @dblclick="onEdit">{{event.endTime}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Duration: </td>
                    <td>
                      <template v-if="editing">
                        <select v-model="event.duration" @change="onChangeDuration">
                          <option v-for="n in arrayDuration" :value="n">{{n}}</option>
                        </select>
                      </template>
                      <span v-else @dblclick="onEdit">{{event.duration}} HR</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Time zone: </td>
                    <td>
                      {{event.timeZone}}
                    </td>
                  </tr>
                </table>
                <p class='textError' v-if="textErrorEndTime">{{textErrorEndTime}}</p>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Program</span><br/>
              <div class="event-info">{{event.programName}}</div>
              <!--          <div class="add-on-wrapper">-->
              <!--              <div class="event-add-on">-->
              <!--                <input type="checkbox" v-model="event.isOnlineScheduler" id="is-online-scheduler" @change="updateIsLiveEvent('ONLINE_SCHEDULER')"/>-->
              <!--                <label for="is-online-scheduler">Toggle</label>-->
              <!--              </div>-->
              <!--              <div class="text" :class="{'online-text': event.isOnlineScheduler}">Online Scheduler</div>-->
              <!--          </div>-->
            </div>
            <div class="col-md-3">
              <span class="event-title">On Site Instructions</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.onsiteInstruction"></textarea>
                <span v-else @dblclick="onEdit">{{event.onsiteInstruction}}</span>
              </div>
            </div>
          </div>

          <!-- Building/Suite, Aduro Arrival Time, On Site Contact, Parking Instructions -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-3">
              <span class="event-title">Building/Suite</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.building"></textarea>
                <span v-else @dblclick="onEdit">{{event.building}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">ADURO Arrival Time</span><br/>
              <div class="event-info">
                <select v-if="editing" v-model="event.aduroArrivalTime">
                  <option v-for="time in listTime" :value="time.name">{{time.name}}</option>
                </select>
                <span v-else @dblclick="onEdit">{{event.aduroArrivalTime}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">On Site Contact</span><br/>
              <div class="event-info">

                <template v-if="editing">
                  <input class="mb-1" type="text" v-model="event.contactName" placeholder="Contact Name"/><br>
                  <input class="mb-1" type="email" v-model="event.email" placeholder="Contact Email"/><br>
                  <input class="mb-1" type="tel" v-model="event.phone" placeholder="Contact Phone"/><br>
                </template>

                <span v-else @dblclick="onEdit">
                {{event.contactName}}
              </span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Parking Instructions</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.parkingInformation"></textarea>
                <span v-else @dblclick="onEdit">{{event.parkingInformation}}</span>
              </div>
            </div>
          </div>

          <!-- Location, Participation, Add-ons, Live -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-3">
              <span class="event-title">Location</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.eventLocation"></textarea>
                <span v-else @dblclick="onEdit">{{event.eventLocation}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Total Participants</span><br/>
              <div class="event-info">
                 <input v-if="editing" v-model="event.projPart"/>
                 <span v-else @dblclick="onEdit">{{event.projPart}}</span>
              </div>
              <span class="event-title margin-top-16px">Participation</span><br/>
              <div class="event-info">
                <div class="oval oval-red"></div>
                <span>{{event.numParticipant}}/{{event.projPart}} participants</span>
              </div>
            </div>
            <div class="col-md-3">
              <span class="event-title">Add-ons</span><br/>
              <div class="event-info">
                <div v-for="(item, index) in addOns.slice(0, 7)" :key="index" class="add-on-wrapper" v-if="item.isShow">
                  <div class="event-add-on mb-1">
                    <input type="checkbox" :disabled="isReadOnly" :id="item.key" v-model="item.value" @change="checkboxToggle(item)"/>
                    <label :for="item.key">Toggle</label>
                  </div>
                  <div class="text">{{ item.text }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="event-info">
                <div v-for="(item, index) in addOns.slice(7, 10)" :key="index" class="add-on-wrapper" v-if="item.isShow">
                  <div class="event-add-on mb-1">
                    <input type="checkbox" :disabled="isReadOnly" :id="item.key" v-model="item.value" @change="checkboxToggle(item)"/>
                    <label :for="item.key">Toggle</label>
                  </div>
                  <div class="text">{{ item.text }}</div>
                </div>
              </div>
            </div>        
          </div>

          <!-- On Site Contacts -->
          <div class="event-detail-body row">
            <div class="col-md-12 liner"></div>
          </div>

          <!-- Title -->
          <div class="event-detail-body row">
            <div class="col-md-6 event-information noPaddingLeft">
              On Site Contacts
            </div>
          </div>

          <!-- Contact Info -->
          <div class="event-detail-body row" v-if="event.contactName">
            <div class="col-md-4 margin-top-16px">
              <div class="wrapper-text">
                <div class="event-info">{{event.contactName}}</div>
                <div class="event-info">{{event.email}}</div>
                <div class="event-info">{{event.phone}}</div>
              </div>
            </div>
            <div class="col-md-4 margin-top-16px">
                <template v-if="showAddSecondContactButton">
                  <div class="paddingTop27px">
                    <button class="btn-add-second-contact" title="Add secondary on site contacts" @click="onEdit">+</button>
                  </div>
                </template>
                <template v-else>
                  <template v-if="editing">
                     <div class="event-info">
                      <input class="mb-1" type="text" v-model="event.secondContactName" placeholder="Enter Secondary On Site Contact's Name"/><br>
                      <input class="mb-1" type="email" v-model="event.secondEmail" placeholder="Enter Secondary On Site Contact's Email"/><br>
                      <input class="mb-1" type="tel" v-model="event.secondPhone" placeholder="Enter Secondary On Site Contact's Phone"/><br>
                     </div>
                  </template>
                  <div class="wrapper-text" v-else>
                    <div class="event-info" @dblclick="onEdit">{{event.secondContactName}}</div>
                    <div class="event-info" @dblclick="onEdit">{{event.secondEmail}}</div>
                    <div class="event-info" @dblclick="onEdit">{{event.secondPhone}}</div>
                  </div>
                </template>
            </div>
          </div>

          <!-- Email -->
          <div class="event-detail-body row">
            <div class="col-md-12 liner"></div>
          </div>

          <!-- Title -->
          <div class="event-detail-body row">
            <div class="col-md-6 event-information noPaddingLeft">
              <span>Email</span>
              <span class="view-history-text" @click="onViewMailHistory">View History</span>
            </div>
            <div class="col-md-6 noPaddingRight noPaddingLeft align-right-item">
              <div class="staffing-edit-btn">
                <button class="ap-btn secondary" :disabled="isReadOnly" @click="onManageEmail">Email Client</button>
              </div>
            </div>
          </div>

          <!-- Email Info -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-12 email-text noPaddingLeft">
              Last Email Sent: {{event.emailReminderStatus | templateName}}
            </div>
          </div>

          <!-- Staff & Slot Management -->
          <div class="event-detail-body row">
            <div class="col-md-12 liner"></div>
          </div>

          <!-- Title -->
          <div class="event-detail-body row">
            <div class="col-md-9 event-information noPaddingLeft">
              Staff & Slot Management
            </div>
            <div class="col-md-3 noPaddingRight noPaddingLeft align-right-item">
              <div class="staffing-edit-btn">
                <button class="ap-btn secondary" :disabled="isReadOnly" @click="onManageEventStaffingDetail">Manage</button>
              </div>
            </div>
          </div>

          <!-- Leads, Concierge, Screeners -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-12 noPaddingLeft">
              <div class="wrapper-text-number display-inline">
                <div class="oval oval-red"></div>
                <span class="number">{{event.numStaffLead}}/{{event.maxStaffLead}} Leads</span>
              </div>
              <div class="wrapper-text-number display-inline">
                <div class="oval oval-red margin-left-8px"></div>
                <span class="number">{{event.numStaffConcierge}}/{{event.maxStaffConcierge}} Phlebotomists</span>
              </div>
              <div class="wrapper-text-number display-inline">
                <div class="oval oval-red margin-left-8px"></div>
                <span class="number">{{event.numStaffScreener}}/{{event.maxStaffScreener}} Screeners</span>
              </div>
            </div>
          </div>

          <!-- Shipping -->
          <div class="event-detail-body row">
            <div class="col-md-12 liner"></div>
          </div>

          <!-- Title -->
          <div class="event-detail-body row">
            <div class="col-md-6 event-information noPaddingLeft">
              Shipping
            </div>
            <div class="col-md-6 event-information noPaddingRight noPaddingLeft align-right-item">
              <div class="staffing-edit-btn">
                <button class="ap-btn secondary" :disabled="isReadOnly" @click="generatePackingSlipBtn()">Generate Packing Slip</button>
              </div>
            </div>
          </div>

          <!-- Address, Supplies Tracking, Packing Slip Tracking, Tracking Number -->
          <div class="event-detail-body row margin-top-16px">
            <div class="col-md-3">
              <span class="event-title">Address</span><br/>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.shippingAddress"></textarea>
                <span v-else @dblclick="onEdit">{{event.shippingAddress}}</span>
              </div>
            </div>

            <div class="col-md-3">
              <span class="event-title">Supplies Tracking</span>
              <div class="supplies-tracking-status margin-bottom-10px">
                <div class="oval" :class="shippingStatus !== '' ? 'oval-green' : 'oval-red'"></div>
                <span
                  class="">{{event.trackingNumber !== '' ? (shippingStatus !== '' ? shippingStatus : 'Shipping info not entered') : 'Shipping info not entered'}}</span>
              </div>
            </div>

            <!--        <div class="col-md-3">-->
            <!--          <span class="event-title">Packing Slip Tracking</span>-->
            <!--          <div class="supplies-tracking-status margin-bottom-10px">-->
            <!--            <div class="oval" :class="shippingStatus !== '' ? 'oval-green' : 'oval-red'"></div>-->
            <!--            <span-->
            <!--              class="">{{event.trackingNumber !== '' ? (shippingStatus !== '' ? shippingStatus : 'Shipping info not entered') : 'Shipping info not entered'}}</span>-->
            <!--          </div>-->
            <!--        </div>-->

            <div class="col-md-3">
              <span class="event-title">Tracking Number</span>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.trackingNumber"></textarea>
                <span v-else @dblclick="onEdit">{{event.trackingNumber}}</span>
              </div>
            </div>

            <div class="col-md-3">
              <span class="event-title">Shipping Note</span>
              <div class="event-info">
                <textarea v-if="editing" v-model="event.shippingNote"></textarea>
                <span v-else @dblclick="onEdit">{{event.shippingNote}}</span>
              </div>
            </div>
          </div>

          <!-- Related Events -->
          <div class="event-detail-body row">
            <div class="col-md-12 liner"></div>
          </div>

          <!-- Title -->
          <div class="series-related-events-section">
            <div class="related-events-top event-detail-body row">
              <div class="col-md-6 event-information noPaddingLeft">
                Related Events
                <span v-if="!event.relatedEvents.length">(0)</span>
                <span v-else>({{event.relatedEvents.length + 1}})</span>
              </div>

              <div class="col-md-6 noPaddingRight noPaddingLeft align-right-item">
                <div class="staffing-edit-btn">
                  <button v-if="!event.relatedEvents.length" class="btn-add-related ap-btn secondary" @click="onManageRelatedEvent">Create Related Events</button>
                  <button v-else class="btn-add-related ap-btn secondary"
                          :disabled="isReadOnly"
                          @click="onManageRelatedEvent">
                    Manage Related Events
                  </button>
                </div>
              </div>
            </div>

            <!-- Related Events Info -->
            <div class="related-event-container event-detail-body row">
              <template v-if="event.relatedEvents.length > 0">
                <div class="col-md-3 margin-top-16px">
                  <div class="related-event-item main-event">
                    <div class="event-name" @click="relatedEventItemClick(event.id)">{{event.eventName}}</div>
                  </div>
                </div>
              </template>
              <div v-for="reEvent in event.relatedEvents" class="col-md-3 margin-top-16px">
                <div class="related-event-item">
                  <div class="event-name" @click="relatedEventItemClick(reEvent.id)">{{reEvent.eventName}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- History -->
          <div v-if="event.status !== 'DRAFTS'">
            <div class="event-detail-body row">
              <div class="col-md-12 liner"></div>
            </div>

            <!-- History Title-->
            <div class="event-detail-body row">
              <div class="col-md-6 event-information noPaddingLeft">
                Change History ({{getEventDetailHistory.length}})
              </div>
            </div>

            <!-- History Table -->
            <div class="event-detail-body row margin-top-16px">
              <div class="history-table-container">
                <div class="list-loading d-flex justify-content-center" v-if="getIsLoadingEventDetailHistory">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-else>
                  <b-table v-if="getEventDetailHistory.length > 0" :fields="changeHistoryTableFields" no-border-collapse bordered hover head-variant="light" :items="getEventDetailHistory">
                    <template slot="cell(fieldName)" slot-scope="row">
                      {{ row.item.fieldName }}
                    </template>
                  </b-table>
                  <div v-else class="justify-content-center">No history found.</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </modal>
    <RelatedEventsModal/>
    <ModalChangeToggleVaccines
      :onCheckToggleOnOff="onCheckToggleOnOff"
      :loadingCovidSelect="loadingCovidSelect"
      :addOns="addOns"
      :nameModal="nameModalRemmoved"
      :textQuestion="textQuestionToggleRemoved"
      :textDescription="textDescriptionToggleRemoved"
    />
    <ModalChangeToggleVaccines
      :onCheckToggleOnOff="onCheckToggleOnOff"
      :loadingCovidSelect="loadingCovidSelect"
      :addOns="addOns"
      :nameModal="nameModalSwitch"
      :textQuestion="textQuestionToggleSwitch"
      :textDescription="newTextDescriptionToggleSwitch"
    />
    <ModalChangeTimeEvent
      :onUpdateEventAction="onUpdateEventAction"
      :loading="loadingUpdate"
    />
  </div>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import 'vue-awesome/icons/search';
  import Icon from 'vue-awesome/components/Icon';

  import DatePicker from 'vuejs-datepicker';
  import VueDropdown from 'vue-dropdowns';
  import VueSelect from 'vue-select';
  import _ from 'lodash';
  import Vue from 'vue';
  import VueSlider from 'vue-slider-component';
  import consts from '../../../_consts';
  import moment from 'moment';
  import VueGoogleAutocomplete from 'vue-google-autocomplete';
  import RelatedEventsModal from './RelatedEventsModal';
  import ModalChangeToggleVaccines from '../ModalChangeToggleVaccines';
  import ModalChangeTimeEvent from '../ModalChangeTimeEvent';

  export default {
    name: 'eventDetailModal',
    components: {
      VueSlider,
      Icon,
      DatePicker,
      VueDropdown,
      VueSelect,
      VueGoogleAutocomplete,
      RelatedEventsModal,
      ModalChangeToggleVaccines,
      ModalChangeTimeEvent
    },
    props: {},
    data () {
      return {
        editing: false,
        event: {
          relatedEvents: []
        },
        shippingStatus: '',
        program: '',
        listTime: consts.listTime,
        addOns: consts.addOns,
        changeHistoryTableFields: [
          {
            key: 'fieldName',
            text: 'Field Name',
            value: false
          },
          {
            key: 'updatedBy',
            text: 'Updated By',
            value: false
          },
          {
            key: 'oldValue',
            text: 'Old Value',
            value: false
          },
          {
            key: 'newValue',
            text: 'New Value',
            value: false
          },
          {
            key: 'timeModified',
            text: 'Time',
            value: false
          }
        ],
        onChangeEventLive: null,
        onChangeEvent: null,
        loadingCovidSelect: false,
        oldStartTime: null,
        oldEndTime: null,
        textQuestionToggleRemoved: 'Are you sure you want to remove vaccine add-on? All vaccine-related appointments within this event will be canceled.',
        textDescriptionToggleRemoved: 'Members will receive a cancellation email.',
        textQuestionToggleSwitch: 'Are you sure you want to change the Flu/Covid Vaccines event type/add-on?',
        textDescriptionToggleSwitch: 'All scheduled vaccine-related appointments under this event will be automatically switched to this new event vaccine type - ',
        nameModalRemmoved: 'modalChangeToggleVaccinesTypeRemoved',
        nameModalSwitch: 'modalChangeToggleVaccinesSwitched',
        loadingUpdate: false
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('eventDetailModal');
      },
      beforeOpen (params) {
        this.onChangeEventLive = params.params.onChangeEventLive;
        this.onChangeEvent = params.params.onChangeEvent;
        this.loadEvent(params.params.eventId);
      },
      beforeClose () {
        this.createNewEventClick();
      },
      opened () {
        this.updateNextZIndex('eventDetailModal');
      },
      preventSave (event) {
        if (event.target.classList.contains('btn-save')) {
          return false;
        }
        let classes = ['cell', 'day', 'selected', 'prev', 'up', 'next', 'blank'];
        if (classes.find(e => event.target.classList.contains(e))) {
          return true;
        }
        let types = ['input', 'button', 'textarea', 'select', 'label', 'span'];
        return types.includes(event.target.tagName.toLowerCase());
      },
      isParticipantValid () {
        if (this.event.numParticipant > this.event.projPart) {
          this.$toastr('error', 'Total Participants must be greater or equal number of current participants', '');
          return false;
        }
        return true;
      },
      onSave (event) {
        if (!this.editing) return;
        if (this.preventSave(event)) return;
        if (!this.checkTimeGreater(this.event.startTime, this.event.endTime)) return;
        if (!this.isParticipantValid()) return;
        if (this.oldStartTime !== this.event.startTime || this.oldEndTime !== this.event.endTime) {
          this.$modal.show('modalChangeTimeEvent');
          return;
        }
        this.onUpdateEventAction();
      },
      onEdit () {
        if (this.isReadOnly) return;
        this.editing = true;
      },
      updateIsLiveEvent (type) {
        let isCheck = false;
        switch (type) {
          case 'LIVE':
            isCheck = this.event.isLive;
            break;
          case 'ONLINE_SCHEDULER':
            isCheck = this.event.isOnlineScheduler;
            break;
          default:
            break;
        }
        this.actionUpdateIsLiveEvent({
          eventId: this.event.id,
          isCheck: isCheck || false,
          onlineType: type
        }).then((response) => {
          this.onChangeEventLive(isCheck);
          if (response.message) {
            this.$toastr('error', response.message, '');
          } else {
            this.$toastr('success', 'Update event successful!', '');
          }
        });
      },
      onViewMailHistory () {
        this.$modal.show('EmailHistoriesManagementModal', { eventId: this.event.id });
      },
      onManageRelatedEvent () {
        this.$modal.show('relatedEventsModal', this.event);
      },
      onManageEmail () {
        this.$modal.hide('manageEmailModal');
        this.$modal.show('manageEmailModal', {
          eventId: this.event.id,
          isManageDetails: true
        });

        this.updateNextZIndex('manageEmailModal');
      },
      onManageEventStaffingDetail () {
        let params = {
          eventId: this.event.id,
          routerName: this.$route.name,
          eventName: this.event.eventName
        };
        this.$modal.show('eventStaffingDetailModal', { ...params, onChangeEventDetail: this.onChangeEventDetail });
      },
      generatePackingSlipBtn () {
        this.generatePackingSlip(this.event.id);
      },
      relatedEventItemClick (eventId) {
        this.loadEvent(eventId);
      },
      loadEvent (eventId) {
        this.editing = false;
        this.eventId = eventId;
        this.shippingStatus = '';
        this.actionGetEventById(this.eventId).then(response => {
          this.event = response.event;
          this.event.endTime = this.addTimeWithDuration(response.event.startTime, response.event.duration);
          this.oldStartTime = response.event.startTime;
          this.oldEndTime = response.event.endTime;
          if (response.message === null) {
            // reset and update add ons
            let strAddOns = localStorage.getItem(consts.LOCAL_STORE.addOns);
            let arrAddOns = strAddOns.split(',');

            this.addOns.forEach(addOn => { addOn.value = false; addOn.isShow = false });
            this.addOns.forEach(addOn => {
              if (this.event.addOns.includes(addOn.key)) {
                addOn.value = true;
              }
              arrAddOns.forEach(ele => {
                if (ele === addOn.key) {
                  addOn.isShow = true;
                }
              });
            });

            // get shipping status
            if (this.event && this.event.trackingNumber) {
              this.actionGetTrackingStatus({eventId: this.eventId, trackingNumber: this.event.trackingNumber}).then(res => {
                this.shippingStatus = (res && res.shippingStatus && res.shippingStatus.trackingStatusDescription) || '';
              });
            }

            // get event change history
            if (this.event.id && this.event.status !== 'DRAFTS') {
              this.actionGetEventHistory(this.event.id);
            }
          }

          this.$store.commit('MUTATION_SET_CURRENT_EVENT', this.event);
        });
      },
      minutes () {
        let range = _.range(0, 60);
        return _.map(range, value => {
          return (value > 9 ? '' : '0') + value;
        });
      },
      formatTime (hour, minute, period) {
        return hour + ':' + minute + ' ' + period;
      },
      parseTime (time) {
        if (!time) {
          return { hour: '', minute: '', period: 'AM' }
        }

        let period = time.split(' ')[1];
        let fullTime = time.split(' ')[0].split(':');

        return {
          hour: fullTime[0],
          minute: fullTime[1],
          period: period
        }
      },
      checkboxToggle (item) {
        let obj = {
          clientId: this.event.clientId,
          eventId: this.event.id,
          key: item.key,
          isAdd: item.value
        };
        const covidAndFlushotAddons = consts.addOns.slice(7, 10).map(addOn => addOn.key);
        if (covidAndFlushotAddons.includes(item.key)) {
          if (this.addOns.slice(7, 10).every(x => x.value === false)) {
            this.$modal.show(this.nameModalRemmoved, obj);
            return;
          }
          if (this.addOns.slice(7, 10).find(x => x.key === item.key) && this.addOns.slice(7, 10).some(x => x.key !== item.key && x.value === true)) {
            this.newTextDescriptionToggleSwitch = this.textDescriptionToggleSwitch + item.text;
            this.$modal.show(this.nameModalSwitch, obj);
            return;
          }
        }
        // if (this.addOns.slice(7, 10).every(x => x.value === false)) {
        //   this.$modal.show(this.nameModalRemmoved, obj);
        //   return;
        // }
        // if (this.addOns.slice(7, 10).find(x => x.key === item.key) && this.addOns.slice(7, 10).some(x => x.key !== item.key && x.value === true)) {
        //   this.newTextDescriptionToggleSwitch = this.textDescriptionToggleSwitch + item.text;
        //   this.$modal.show(this.nameModalSwitch, obj);
        //   return;
        // }
        this.onCheckToggleOnOff(obj);
      },
      setPlace (data, place) {
        this.event.fullAddress = place.formatted_address;
        let req = Vue.axios.create();
        req.get('https://maps.googleapis.com/maps/api/timezone/json', {
          params: {
            location: `${place.geometry.location.lat()},${place.geometry.location.lng()}`,
            timestamp: `${Math.round((new Date().getTime()) / 1000)}`,
            key: this.googleMapApiKey === '' ? localStorage.getItem(consts.LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
          }
        }).then((response) => {
          if (response.data) {
            this.event.timeZone = this.getTimeZone(response.data.timeZoneName);
          } else {
            Vue.prototype.$toastr('error', 'Error calling Google Maps API', '');
          }
          this.isInSetPlace = false;
        });
      },
      setPlaceShipping (data, place) {
        this.event.shippingAddress = place.formatted_address;
      },
      getTimeZone (tzString) {
        if (tzString.length === 0) {
          return '';
        }
        let str = '';
        let index = 0;
        while (index >= 0) {
          str += tzString.substr(0, 1);
          index = tzString.indexOf(' ');
          tzString = tzString.substring(index + 1);
        }
        return str;
      },
      onChangeDuration () {
        this.event.endTime = this.addTimeWithDuration(this.event.startTime, this.event.duration);
        this.event.startTime = this.subtractTimeWithDuration(this.event.endTime, this.event.duration);
      },
      onChangeStartTime () {
        if (!this.checkTimeGreater(this.event.startTime, this.event.endTime)) return;
        this.event.endTime = this.addTimeWithDuration(this.event.startTime, this.event.duration);
        this.event.duration = this.calculateDuration(this.event.startTime, this.event.endTime);
      },
      onChangeEndTime () {
        if (!this.checkTimeGreater(this.event.startTime, this.event.endTime)) return;
        this.event.startTime = this.subtractTimeWithDuration(this.event.endTime, this.event.duration);
        this.event.duration = this.calculateDuration(this.event.startTime, this.event.endTime);
      },
      checkTimeGreater (startTime, endTime) {
        return moment(startTime, 'h:mm A').isBefore(moment(endTime, 'h:mm A'));
      },
      calculateDuration (startTime, endTime) {
        var start = moment([moment(startTime, 'h:mm A').hour(), moment(startTime, 'h:mm A').minutes(), '00'], 'HH:mm:ss');
        var end = moment([moment(endTime, 'h:mm A').hour(), moment(endTime, 'h:mm A').minutes(), '00'], 'HH:mm:ss');
        return moment.duration(end.diff(start)).asHours();
      },
      addTimeWithDuration (time, duration) {
        return moment(time, 'h:mm A').add(duration, 'hours').format('h:mm A');
      },
      subtractTimeWithDuration (time, duration) {
        return moment(time, 'h:mm A').subtract(duration, 'hours').format('h:mm A');
      },
      onChangeEventDetail (item) {
        this.event.maxStaffLead = item.maxStaffLead;
        this.event.maxStaffConcierge = item.maxStaffConcierge;
        this.event.maxStaffScreener = item.maxStaffScreener;
        this.onChangeEvent(this.event);
      },
      onCheckToggleOnOff (obj) {
        let addOn = _.find(this.addOns, {'key': obj.key});
        this.updateAddOn(obj).then(() => {
          this.event.addOns = this.addOns.filter(e => e.value === true)
            .map(e => e.key)
            .join(',');
          if (this.addOns.slice(7, 10).find(x => x.key === obj.key)) {
            this.addOns.slice(7, 10).forEach(element => {
              if (obj.key !== element.key) {
                element.value = false;
              }
            });
          }
          this.$modal.hide(this.nameModalRemmoved);
          this.$modal.hide(this.nameModalSwitch);
          this.loadingCovidSelect = false;
          Vue.prototype.$toastr('success', 'Update event successful');
        }).catch(() => {
          addOn.value = !obj.isAdd;
        });
      },
      onUpdateEventAction () {
        this.loadingUpdate = true;
        this.updateEventAction(Object.assign(this.event, {prefDate: moment(this.event.prefDate).format('MM/DD/YYYY')})).then(response => {
          this.editing = false;
          this.loadingUpdate = false;
          this.oldStartTime = this.event.startTime;
          this.oldEndTime = this.event.endTime;
          this.$modal.hide('modalChangeTimeEvent');
          this.onChangeEvent(this.event);
        });
      },
      ...mapActions({
        actionGetEventById: 'ACTION_GET_EVENT_BY_ID',
        actionGetTrackingStatus: 'ACTION_GET_TRACKING_STATUS',
        actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT',
        actionGetEventHistory: 'ACTION_GET_EVENT_DETAIL_HISTORY',
        generatePackingSlip: 'ACTION_GENERATE_PACKING_SLIP',
        updateAddOn: 'ACTION_UPDATE_EVENT_ADD_ON',
        createNewEventClick: 'ACTION_CREATE_NEW_EVENT',
        updateEventAction: 'ACTION_UPDATE_EVENT',
        updateNextZIndex: 'ACTION_UPDATE_NEXT_ZINDEX'
      }),
      ...mapMutations({
        setIsLoading: 'MUTATION_SET_IS_LOADING'
      })
    },
    computed: {
      arrayDuration () {
        let range = [];
        for (let i = 1; i <= 24; i += 0.5) {
          range.push(i);
        }
        return range;
      },
      textErrorEndTime () {
        let beginningTime = moment(this.event.startTime, 'h:mm A');
        let endTime = moment(this.event.endTime, 'h:mm A');
        if (!beginningTime.isBefore(endTime)) {
          return 'The end time must be greater than the start time'
        }
        return null;
      },
      isReadOnly () {
        return this.event.status === 'ARCHIVED';
      },
      showAddSecondContactButton: function () {
        return (this.event.contactName && !this.editing && !this.event.secondContactName);
      },
      ...mapGetters({
        getIsLoadingModal: 'GETTER_IS_LOADING_MODAL',
        getEventForChangeOrderModal: 'GETTER_GET_EVENT_FOR_CHANGE_ORDER',
        googleMapApiKey: 'GETTERS_GOOGLE_API_KEY',
        getEventDetailHistory: 'GETTERS_GET_EVENT_DETAIL_HISTORY',
        getIsLoadingEventDetailHistory: 'GETTERS_GET_IS_LOADING_EVENT_DETAIL_HISTORY'
      })
    }
  }
</script>

<style lang="less" scoped>
@import '../../../styles/variables.less';

.custom-modal {
  background: rgba(0, 0, 0, 0.4);

  .modal-padding {
    padding: 24px 40px 20px 40px;
    min-height: 100vh;
  }

  .icon-back {
    margin: 1.5px 1.5px;
    width: 27px;
    height: 27px;
    color: @grey-3;
    background-color: @grey-3;
    -webkit-mask: url('../../../../static/img/backward-line.svg') no-repeat center;
    mask: url('../../../../static/img/backward-line.svg') no-repeat center;
    background: url('../../../../static/img/backward-line-grey.svg');
  }
  .icon-align {
    margin-bottom: 10px;
    padding-left: 8px;
    margin-top: 24px;

    &:hover{
      cursor: pointer;
    }
  }

  .series-related-events-section{
    .related-events-top{
      justify-content: space-between;
      margin-top: -10px;

      .related-events-top-left{
        display: flex;
        align-items: center;

        .related-events-title{
          color: @black-2;
          font-size: 16px;
          font-weight: bold;
        }

        .related-event-count{
          color: @grey-9;
          font-size: 12px;
          margin-left: 8px;
          font-weight: normal;
          text-transform: uppercase;
        }
      }

      .button-containers{
        margin-left: 12px;

        .btn-left{
          padding: 6px 24px;
          font-size: 16px;
          font-weight: 600;
        }
        .btn-right{
          height: 24px;
          padding: 0 12px;
          font-size: 12px;
        }
      }
    }

    .related-event-container{
      .related-event-item{
        height: 32px;
        padding: 8px;
        border: 1px solid @grey-4;
        border-radius: 4px;
        margin-bottom: 16px;

        .event-name{
          color: @black-3;
          font-family: @font-family-main;
          font-size: 12px;
          line-height: 16px;
        }

        &:hover{
          cursor: pointer;
        }
      }

      .main-event {
        background: @grey-4;
      }
    }

    .btn-add-related-container{
      margin-top: 8px;

      .btn-add-related{
        font-size: 12px;
        padding: 6px 12px;
      }
    }
  }
  .event-detail-header {
    .wrapper-participant {
      display: flex;
      justify-items: flex-end;
      flex-direction: column;
      text-align: right;
    }
    .wrapper-multi-select {
      .multi-select-text{
        padding: 0;
        width: 275px;
      }
      .multiselect{
        min-height: 38px;
      }
      .multiselect__tags{
        border: none;
        min-height: 38px;
      }
      .multiselect__content-wrapper{
        // background-color: none;
        // background: none;
        .multiselect__element:last-child{
          border-bottom: none;
        }
      }
    }
    .event-details {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0.2px;
      line-height: 32px;
    }
    .client-name {
      color: @light-blue;
      font-family: @font-family-main;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0.17px;
      line-height: 28px;
    }
    .event-name {
      color: @grey-8;
      font-family: @font-family-main;
      font-size: 16px;
      line-height: 24px;
      text-align: right;
      float: right;
      clear: both;
    }
    .map {
      height: 200px;
      width: 100%;
      border: 1px solid @grey-8;
    }
  }
  .modal-close-img {
    display: flex;
    justify-content: flex-end;

    &:hover{
      cursor: pointer;
    }
    .icon-close {
      margin: 1.5px 1.5px;
      width: 16px;
      height: 16px;
      color: @black-3;
      background-color: @black-3;
      -webkit-mask: url('../../../../static/img/action-close-black.svg') no-repeat center;
      mask: url('../../../../static/img/action-close-black.svg') no-repeat center;
      background: url('../../../../static/img/action-close-black.svg');
    }
  }
  .event-detail-body {
    align-items: flex-start;

    textarea, input {
      padding: 4px;
      width: 90%;
    }

    .email-text {
      color: #1D1D1D;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }

    .col-md-3:nth-child(4n + 1) {
      padding-left: 0;
    }

    .col-md-3:nth-child(4n) {
      padding-right: 0;
    }

    .col-md-4:nth-child(3n + 1) {
      padding-left: 0;
    }

    .col-md-4:nth-child(3n) {
      padding-right: 0;
    }

    .view-history-text {
      color: @blue-2;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.1px;
      line-height: 24px;
      cursor: pointer;
      margin-left: 16px;
    }
    .staff-header {
      color: @black-2;
      font-size: 16px;
      font-weight: bold;
    }
    .staffing-edit-btn {
      .ap-btn{
        padding: 4px 24px;
        text-transform: none;
        border: 1px solid #B9B9B9;
        font-size: 16px;

        &.secondary {
          color: @blue-2;
          &:hover {
            background-color: @blue-2;
            color: @white;
          }

          &:disabled {
            opacity: 1;
            background: @grey-3;
            color: white;
          }
        }
      }

      .spinner-border {
        width: 1rem;
        height: 1rem;
        color: #fff;
      }
    }

    .text {
      //width: 118px;
      color: @black-3;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;

      &.online-text {
        color: @blue-2;
      }
    }

    .number {
      width: 177px;
      color: @black-2;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }

    .group-btn-manage-detail{
      display: flex;
      justify-content: flex-end;

      .icon-email-wrapper{
        width: 32px;
        height: 32px;
        background-color: @light-blue;
        padding: 4px;
        border-radius: 4px;
        &:hover{
          cursor: pointer;
        }

        .icon-email{
          width: 24px;
          height: 24px;
          background: url('../../../../static/img/24px-mail-white.svg');
        }
      }

      .ap-btn{
        padding: 6px 17px;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
      }

      .btn-left{
        margin-right: 8px;
      }

    }

    .manage-detail {
      height: 32px;
      width: 184px;
      border: 1px solid @light-blue;
      border-radius: 4px;
      float: right;
      .manage-text {
        color: @light-blue;
        font-family: @font-family-main;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
        line-height: 20px;
        cursor: pointer;
        position: relative;
        top: 50%;
        left: 50%;
        float: left;
        transform: translate(-50%, -50%);
      }
    }
    .btn-request-change{
      min-width: 215px;
    }
    .request-change {
      height: 32px;
      width: 184px;
      background-color: #AAA7A4;
      border-radius: 4px;
      .request-text {
        color: @white;
        font-family: @font-family-main;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
        line-height: 20px;
        cursor: pointer;
        position: relative;
        top: 50%;
        left: 50%;
        float: left;
        transform: translate(-50%, -50%);
        text-transform: uppercase;
      }
    }
    .wrapper-text-number {
      margin-right: 24px;
    }

    .liner {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid @grey-4;
      margin-top: 24px;
      margin-bottom: 24px;
    }
    .liner-for-staff {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid @grey-4;
      margin-top: 22px;
      margin-bottom: 18px;
    }
    .event-information {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
    }
    .event-title {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      text-transform: none;
      margin-top: 14px;
    }
    .event-info {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
      margin-top: 4px;
    }
    .shipping-notes {
      color: @grey-8;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }
    .input-shipping-notes {
      height: 78px;
      width: 402px;
      border: 1px solid @grey-3;
      border-radius: 4px;
    }
    .on-site-instruction {
      height: 63px;
      width: 184px;
      border: 1px solid @grey-3;
      border-radius: 4px;
      color: #1D1D1D;
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      line-height: 16px;
    }
    .tracking-number {
      height: 31px;
      width: 402px;
      border-radius: 4px;
      border: 1px solid @grey-3;
      text-transform: uppercase;
      color: #424242;
      font-family: @font-family-main;
      font-size: 12px;
    }
    .supplies-tracking-status {
      color: @black-2;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }
  
    .wrapper-text {
      padding: 8px;
      border: 1px solid @grey-3;
      border-radius: 4px;
    }

    .textError {
      color:#E93000;
    }
    .history-table-container {
      width: 100%;
    }
  }

  .add-on-wrapper {
      float: left;
      //height: 33px;
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 4px;
      .title {
        color: #626262;
        font-family: @font-family-main;
        font-size: 12px;
        line-height: 16px;
      }
      .event-add-on {
        overflow: hidden;
        margin-right: 8px;

        .add-on-item-wrapper {
          // margin-left: -30px;
          // height: 110px;
        }
        .title {
          margin-top: 20px;
          // color: #fff;
          // background-color: #0080A5;
          .icon-add {
            color: #fff;
            background-color: #00A4D6;
            border: 3px;
            border-radius: 20px;
            width: 16px;
            height: 16px;
            margin-left: 15px;
          }
          .text {
            margin-left: 10px;
            color: #00A4D6;
            font-family: "Open Sans", sans-serif;
            font-size: 12px;
            text-transform: capitalize;
          }
        }
        .add-on-item {
          width: 210px;
          position: relative;
          margin-left: 0;
          margin-top: 15px;
          display: inline-block;
          .text {
            position: absolute;
            left: 45px;
          }
        }
        input[type=checkbox] {
          //height: 0;
          width: 0;
          visibility: hidden;
        }

        label {
          float: left;
          cursor: pointer;
          text-indent: -9999px;
          width: 32px;
          height: 16px;
          background: #fff;
          border-radius: 24px;
          position: relative;
          top: 1px;
          left: 0;
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 0;
        }

        label:after {
          content: '';
          position: absolute;
          top: -0.7px;
          left: -0.7px;
          width: 14px;
          height: 14px;
          background: #fff;
          border-radius: 24px;
          -webkit-transition: 0.3s;
          transition: 0.3s;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }

        input:checked + label {
          background: @blue-2;
          border: 2px solid @blue-2;
          // border: none;
        }

        input:checked + label:after {
          // top: -0.5px;
          left: calc(100% + 4px);
          transform: translateX(-100%);
          //box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
        }

        label:active:after {
          width: 15px;
        }
      }
    }
}

.oval {
  height: 8px;
  width: 8px;
  display: inline-block;
  border-radius: 3px;
  margin-left: 0;
  &.oval-red {
    background-color: #E93000;
  }
  &.oval-green {
    background-color: #68B814;
  }
  &.oval-orange {
    background-color: #FFA71B;
  }
  &.ovalSilver {
    background-color: #D8D8D8;
  }
  &.margin-left-8px {
    margin-left: 8px;
  }
}

.isLoading {
  display: block;
  text-align: center;
  color: #606060;
  height: 100%;
}

.noDisplay {
  display: none;
}

.display-inline {
  display: inline;
}

.padding-top-5px {
  padding-top: 5px;
}

.overlay {
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  cursor: pointer;
}

.spinner-align {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.align-right-item {
  text-align: right;
}

.btn-add-second-contact{
  background-color: rgba(47, 114, 214, 0.8);
  font-size: 16px;
  height: 32px;
	width: 32px;
  border-radius: 50%;
  position: relative;
  border: none;
  &:after,
	&:before {
		content: "";
		display: block;
		background-color: rgb(255,255,255);;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
  &:before {
		height: 1em;
		width: 0.2em;
	}

	&:after {
		height: 0.2em;
		width: 1em;
	}
}
</style>



// WEBPACK FOOTER //
// EventDetailModal.vue?63644780